import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const ChartSection = ({ chartData, formatCurrency, formatTooltipCurrency }) => (
  <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-lg p-8">
    <h3 className="text-lg font-semibold mb-6 text-neutral-800 dark:text-neutral-100">
      Loan Progress Over Time
    </h3>
    <div className="h-80">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData}>
          <defs>
            <linearGradient id="colorPrincipalPaid" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#10b981" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#10b981" stopOpacity={0.2}/>
            </linearGradient>
            <linearGradient id="colorInterestPaid" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#f97316" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#f97316" stopOpacity={0.2}/>
            </linearGradient>
            <linearGradient id="colorOutstanding" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#3b82f6" stopOpacity={0.2}/>
            </linearGradient>
          </defs>
          <XAxis
            dataKey="year"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#6b7280' }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#6b7280' }}
            tickFormatter={(value) => formatCurrency(value)}
          />
          <Tooltip
            contentStyle={{
              background: 'white',
              border: 'none',
              borderRadius: '12px',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
            }}
            formatter={(value) => [formatTooltipCurrency(value), '']}
            labelFormatter={(label) => `Year ${label}`}
          />
          <Legend
            verticalAlign="top"
            height={36}
            iconType="circle"
          />
          <Area
            type="monotone"
            dataKey="Principal Paid"
            stackId="1"
            stroke="#10b981"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorPrincipalPaid)"
          />
          <Area
            type="monotone"
            dataKey="Interest Paid"
            stackId="1"
            stroke="#f97316"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorInterestPaid)"
          />
          <Area
            type="monotone"
            dataKey="Outstanding Principal"
            stackId="2"
            stroke="#3b82f6"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorOutstanding)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default ChartSection;
